<div [ngClass]="type" class="subscription-banner">
  <rt-icon [name]="iconName" size="small" margin-right-small-x></rt-icon>
  <span margin-right-small-xx [innerHTML]="message"> </span>
  <a class="link" *ngIf="!!linkText" [routerLink]="linkUrl" (click)="linkClick.emit()">
    {{ linkText }}
  </a>
  <rt-button
    *ngIf="isDismissible"
    (click)="onCloseClick($event)"
    margin-left-auto
    class="close-btn"
    variant="small-x transparent only-icon"
  >
    <rt-icon name="close" [size]="'small'"></rt-icon>
  </rt-button>
</div>
